import { ILocationIssueSummaryResponse } from '@kcftech/prometheus-client';

export type SortField =
    | 'locationName'
    | 'newIssueCount'
    | 'openIssueCount'
    | 'averageDaysIssueOpened'
    | 'downtimeHoursSaved'
    | 'totalSavings';

type SortDirection = 'asc' | 'desc';

export type SortState = {
    field: SortField;
    direction: SortDirection;
};

/**
 * Sort function for issue summaries by field
 */
export function getSortFunction(
    field: SortField,
    direction: SortDirection,
): (a: ILocationIssueSummaryResponse, b: ILocationIssueSummaryResponse) => number {
    const multiplier = direction === 'asc' ? 1 : -1;

    return (a: ILocationIssueSummaryResponse, b: ILocationIssueSummaryResponse) => {
        switch (field) {
            case 'locationName':
                return (
                    multiplier *
                    a.Location.LocationName.localeCompare(b.Location.LocationName)
                );
            case 'newIssueCount':
                return (
                    multiplier *
                    (a.IssueSummary.NewIssueCount - b.IssueSummary.NewIssueCount)
                );
            case 'openIssueCount':
                return (
                    multiplier *
                    (a.IssueSummary.OpenIssueCount - b.IssueSummary.OpenIssueCount)
                );
            case 'averageDaysIssueOpened':
                return (
                    multiplier *
                    (a.IssueSummary.AverageDaysIssueOpened -
                        b.IssueSummary.AverageDaysIssueOpened)
                );
            case 'downtimeHoursSaved':
                return (
                    multiplier *
                    (a.IssueSummary.DowntimeHoursSaved -
                        b.IssueSummary.DowntimeHoursSaved)
                );
            case 'totalSavings':
                return (
                    multiplier *
                    (a.IssueSummary.TotalSavings - b.IssueSummary.TotalSavings)
                );
            default:
                return 0;
        }
    };
}
